import { useRef } from 'react';
import { join } from 'light-component';
import { Icons } from 'zf-web-components/icons';
import { useTranslation } from '../i18n';
import { theme, Space } from '../../base';
import { Box } from '../box';
import { OperatorButton, OperatorSwitch, OperatorMenu } from './components';
import { OperatorService } from './service';
import styles from './style.module.less';
import type { OperatorProps } from './types';
import type { CSSProperties, ReactElement } from 'react';

export function Operator(props: OperatorProps): ReactElement {
  const { t } = useTranslation();
  const { title = '', menuIcon, children, menuTitle = t('更多'), menuItems = [], suffix } = props;
  const { token } = theme.useToken();
  const { current } = useRef(new OperatorService());

  const overrideStyle: CSSProperties = {
    backgroundColor: token.colorBgContainer,
    borderRadius: '4px 4px 0 0',
    ...(props.style ?? {})
  };

  /**
   * 是否显示菜单前的 icon
   */
  const icon = menuIcon != null ? <Icons name={menuIcon} /> : undefined;

  return (
    <Box style={overrideStyle} className={join(styles.operator, props.className)}>
      <Space wrap>
        <Box className={styles.title}>{title}</Box>
        {suffix}
      </Space>
      <Space wrap>
        <Operator.Menu icon={icon} title={menuTitle} items={current.combine(menuItems)} />
        {children}
      </Space>
    </Box>
  );
}

Operator.Menu = OperatorMenu;
Operator.Button = OperatorButton;
Operator.Switch = OperatorSwitch;
